import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=54a13c8a&scoped=true&"
import script from "./addEmail.vue?vue&type=script&lang=js&"
export * from "./addEmail.vue?vue&type=script&lang=js&"
import style0 from "./addEmail.vue?vue&type=style&index=0&id=54a13c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a13c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a13c8a')) {
      api.createRecord('54a13c8a', component.options)
    } else {
      api.reload('54a13c8a', component.options)
    }
    module.hot.accept("./addEmail.vue?vue&type=template&id=54a13c8a&scoped=true&", function () {
      api.rerender('54a13c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/email/components/addEmail.vue"
export default component.exports